import { connect } from 'react-redux';
import * as R from 'ramda';
import { createSelector } from 'reselect';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import { postPasswordReset } from 'server/api';
import flashRedirect from 'state/actions/flashRedirect';
import React, {Fragment} from "react";

const getInitialValues = createSelector(
  R.path(['location', 'payload', 'code']),
  code => ({ passwordResetKey: code }),
);

const mapStateToProps = state => ({
  hideOnSubmit: true,
  submitLabel: 'Reset password',
  successMessage: 'Password reset! You can now log in with your new password.',
  initialValues: getInitialValues(state),
  fields: [
    {
      type: 'password',
      name: 'password',
      label: 'New password',
      required: true,
      description: (
        <Fragment>
          Minimum 10 characters including 1 number, 1 upper case, and 1 special.
        </Fragment>
      ),
    },
    {
      type: 'password',
      name: 'confirmPassword',
      label: 'Confirm new password',
      required: true,
      validate: (val, allValues) => (
        val !== R.path(['password'], allValues) ? 'Passwords do not match.' : null
      ),
    },
    {
      type: 'text',
      name: 'passwordResetKey',
      label: 'Password reset key',
      required: true,
      hidden: true,
    },
  ],
});

const mapDispatchToProps = dispatch => ({
  onSubmit: async (data) => {
    const resp = await dispatch(postPasswordReset(data));

    // The only response we would get are errors
    if (!resp) {
      // TODO: Should redirect user somewhere else if they're logged in
      dispatch(
        flashRedirect([
          {
            message: 'Password reset successful! Log in below.',
            type: 'success',
            position: 'static',
          },
        ], {
          type: 'LOGIN',
        }),
      );
      return null;
    }

    // Return any errors
    return resp;
  },
});

const ResetPasswordForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormBuilder);

export default ResetPasswordForm;
